module.exports = __webpack_public_path__ + "static/img/youcaiwenhua.06bbd5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/youcaiwenhua.jpg
// module id = /X1v
// module chunks = 5